/* script */
//
//
//
//
//
//
//
//
//
//

import VueLazyload from 'vue-lazyload';
import axios from 'axios';
import bus from '../../bus.js';
import PageBanner from '@/components/PageBanner.vue';
import FeaturedBeats from '@/components/FeaturedBeats.vue';
import LatestBeats from '@/components/LatestBeats.vue';
import Pricing from '@/components/Pricing.vue';
import FullWidthCta from '@/components/FullWidthCta.vue';
import PlayImage from '@/components/elements/PlayImage.vue';


const __vue_script__ = {
	data: function () {
		return {
			products: [],
			beatsOnDeck: [],
			featuredMusic: [],
			audioSources: [],
			bannerimage: ui_data.themeUrl + '/assets/images/header-dj.jpg',
			playButtonSource: ui_data.themeUrl + '/assets/images/svg/play-gradient.svg',
			bannerHeader: '',
			bannerParagraph: '',
			buttons: true,
			loadingState: true,
			leaving: [],
		}
	},
	methods: {
		getModuleProps(module) {
			switch (module) {
				case 'PageBanner':
					return {
						imageSource: this.bannerimage,
						bannerHeader: this.bannerHeader,
						bannerParagraph: this.bannerParagraph,
						showButtons: this.buttons,
					};
				case 'FeaturedBeats': 
					return {
						featuredMusic: this.featuredMusic,
						featuredBeatsHeadline: this.featuredBeatsHeadline,
						featuredGenres: this.featuredGenres,
						featuredMoods: this.featuredMoods,
					};
				case 'LatestBeats': 
					return {
						products: this.products,
						audioSources: this.audioSources,
						loadingState: this.loadingState,
					};
				case 'Pricing':
					return {
						pricingHeader: this.pricingHeader,
						pricingBgImage: this.pricingBgImage,
					};
				case 'FullWidthCta':
					return {
						ctaHeadline: this.ctaHeadline,
						ctaParagraph: this.ctaParagraph,
						ctaButton: this.ctaButton,
						ctaLink: this.ctaLink,
					};
				case 'BeatsList':
					return {
						products: this.products,
						limit: 10,
						audioSources: this.audioSources,
						loading: this.loadingState,
					};
				default:
					return {};
			}
		},
		async fetchData() {
			let vm = this;
			let i = 0;
			let featuredBeats = ui_data.siteFeaturedMusic;

			featuredBeats.forEach( function( track, index ) {
				//Add index to beats
				track['index'] = i;
				vm.beatsOnDeck.push(track);
				i++;
			});
			this.featuredMusic = featuredBeats;

			// Get main playlist
			axios.get( ui_data.homeUrl + '/wp-json/beatstore/v1/beats/subsite/offset/0' )
				.then(response => {
					let beats = response.data;

					beats.forEach( function( track, index ) {
						//Add index to beats
						track['index'] = i;
						vm.beatsOnDeck.push(track);
						i++;
					});
					vm.products = beats;
					bus.$emit( 'beatsOnDeck', vm.beatsOnDeck );
					vm.loadingState = false;
				})
		},
	},
	components: {
		FeaturedBeats,
		LatestBeats,
		Pricing,
		PlayImage,
		PageBanner,
		FullWidthCta,
	},
	props: {
		modules: Array,
	},
	created() {
		this.featuredBeatsHeadline = ui_data.featuredBeatsHeadline;
		this.bannerHeader          = ui_data.HomePageHeadline;
		this.bannerParagraph       = ui_data.HomePageParagraph;
		this.ctaHeadline           = ui_data.ctaHeadline;
		this.ctaParagraph          = ui_data.ctaParagraph;
		this.ctaButton             = ui_data.ctaButton;
		this.ctaLink               = ui_data.ctaLink;
		this.pricingHeader         = ui_data.pricingHeader;
		this.pricingBgImage        = ui_data.pricingBgImage;
		this.featuredGenres        = ui_data.siteFeaturedGenres;
		this.featuredMoods         = ui_data.siteFeaturedMoods;

		if ( ui_data.homePageBackground ) {
			this.bannerimage = ui_data.homePageBackground;
		}

		this.$watch(
			() => this.$route.params.name,
			this.fetchData,
			// fetch the data when the view is created and the data is
			// already being observed
			{ immediate: true }
		)
	}
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-home-wrapper"},_vm._l((_vm.modules),function(module,index){return _c(module,_vm._b({key:index,tag:"component"},'component',_vm.getModuleProps(module),false))}),1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "HomePage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__